module.exports = __webpack_public_path__ + "img/small-owl_4.563a3dd0.jpg";